import {Injectable} from '@angular/core';
import {Http, Response, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../../environments/environment';


@Injectable()
export class CompararService {

  public cotizacion;
  public polizasCompararSource =  new Subject<string>();
  public polizasComparar = this.polizasCompararSource.asObservable();

  constructor(private http:Http) { }


updatePolizasComparar(po: string) {

    this.polizasCompararSource.next(po);
  }

  getComparar(idCotizacion:string, tipoCotizacion:string){
    let url = environment.serviceUrl+'cotizacion/' + idCotizacion + '/tipo/' + tipoCotizacion;
    return this.http.get(url);
  }
  /**
  * Handles error thrown during HTTP call
  * @param error:any
  * @returns {Promise<never>}
  */
  private handleError(error: any): Promise<any> {
  console.error('An error occurred', error); //
  return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/general/comparar.service.ts